import React from "react";
import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { CalendarRange } from "lucide-react";

export const PERIODS = [
  ["all", "كل الفترات"], ["today", "اليوم"], ["7d", "آخر 7 أيام"],
  ["month", "هذا الشهر"], ["lastmonth", "الشهر الماضي"], ["custom", "نطاق مخصص"],
];

const atMidnight = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
const fromInput = (s) => { const [y, m, d] = s.split("-").map(Number); return new Date(y, m - 1, d); };

export function periodRange(period, from, to) {
  const now = new Date();
  const today = atMidnight(now);
  if (period === "today") return { start: today, end: new Date(today.getTime() + 864e5) };
  if (period === "7d") return { start: new Date(now.getTime() - 7 * 864e5), end: null };
  if (period === "month") return { start: new Date(now.getFullYear(), now.getMonth(), 1), end: null };
  if (period === "lastmonth") return { start: new Date(now.getFullYear(), now.getMonth() - 1, 1), end: new Date(now.getFullYear(), now.getMonth(), 1) };
  if (period === "custom") {
    return {
      start: from ? fromInput(from) : null,
      end: to ? new Date(fromInput(to).getTime() + 864e5) : null,
    };
  }
  return { start: null, end: null };
}

export function rangeParams({ start, end }) {
  const p = {};
  if (start) p.start = start.toISOString();
  if (end) p.end = end.toISOString();
  return p;
}

export const PeriodFilter = ({ period, setPeriod, from, setFrom, to, setTo }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid="payments-period-filter">
    <CalendarRange className="w-4 h-4 text-muted-foreground" />
    <Select value={period} onValueChange={setPeriod} dir="rtl">
      <SelectTrigger className="w-40 rounded-full h-9" data-testid="payments-period-select"><SelectValue /></SelectTrigger>
      <SelectContent>
        {PERIODS.map(([k, l]) => <SelectItem key={k} value={k} data-testid={`payments-period-${k}`}>{l}</SelectItem>)}
      </SelectContent>
    </Select>
    {period === "custom" && (
      <>
        <span className="text-xs text-muted-foreground">من</span>
        <Input type="date" value={from} max={to || undefined} onChange={(e) => setFrom(e.target.value)} className="w-40 h-9" data-testid="payments-date-from" />
        <span className="text-xs text-muted-foreground">إلى</span>
        <Input type="date" value={to} min={from || undefined} onChange={(e) => setTo(e.target.value)} className="w-40 h-9" data-testid="payments-date-to" />
      </>
    )}
  </div>
);
